import React, { useContext, useEffect, useState } from 'react'
import 'chartjs-adapter-date-fns'
import {
  FcPortraitMode,
  FcNightPortrait,
  FcOrganization,
  FcDiploma2,
  FcDeployment,
  FcIdea,
  FcButtingIn
} from 'react-icons/fc'
import { apiGet } from 'utils/apiFetch'
import pathObj from 'utils/apiPath'
import CountUp from 'react-countup'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import { Chart } from 'react-google-charts'
import { useNavigate } from 'react-router-dom'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale
} from 'chart.js'
import AuthContext from 'context/AuthContext'
import ODateRangePicker from 'components/shared/datePicker/ODateRangePicker'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale
)

export const lineGraphOptions = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top'
    },
    title: {
      display: false,
      text: ''
    }
  },
  scales: {
    y: {
      beginAtZero: true
    }
  }
}

export const lineGraphData = {
  labels: [],
  datasets: [
    {
      label: 'Users',
      data: [],
      borderColor: '#8FC150',
      backgroundColor: 'rgba(143, 193, 80, 0.2)',
      pointBackgroundColor: '#8FC150',
      pointBorderColor: '#8FC150'
    }
  ]
}

export const lineGraphOptions2 = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top'
    },
    title: {
      display: false,
      text: ''
    }
  },
  scales: {
    y: {
      beginAtZero: true
    }
  }
}

export const lineGraphData2 = {
  labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  datasets: [
    {
      label: 'Sales',
      data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      borderColor: '#8FC150',
      backgroundColor: 'rgba(143, 193, 80, 0.2)',
      pointBackgroundColor: '#8FC150',
      pointBorderColor: '#8FC150'
    }
  ]
}

export const options = {
  title: '',
  colors: ['#8FC150', '#E5E7EB']
}

function Home () {
  const navigate = useNavigate()

  const { t } = useTranslation()
  const { user, logoutUser, updatePageName } = useContext(AuthContext)

  const [dashboardDetails, setDashboardDetails] = useState({})

  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState('')
  const [isReset, setIsReset] = useState(false)
  const handleDateChange = (start, end) => {
    setStartDate(start)
    setEndDate(end)
  }
  const data = [
    ['Task', 'Hours per Day'],
    ['Total Properties', dashboardDetails?.totalProperties],
    ['Sold Properties', dashboardDetails?.totalSoldProperties]
  ]
  const getDashboardDetails = async () => {
    try {
      const payload = {
        start_date: startDate ? dayjs(startDate).format('YYYY-MM-DD') : null,
        end_date: endDate ? dayjs(endDate).format('YYYY-MM-DD') : null
      }
      const path = pathObj.getDashboardDetails
      const result = await apiGet(path, payload)
      setDashboardDetails({ ...dashboardDetails, ...result.data.results })
    } catch (error) {
      console.error('error:', error)
      if (error.response.status === 401 || error.response.status === 409) {
        logoutUser()
      }
    }
  }

  useEffect(() => {
    getDashboardDetails()
  }, [startDate, endDate])
  useEffect(()=>{
    updatePageName(t('NAV_DASHBOARD'))
  },[])

  const handleReset = () => {
    setEndDate('')
    setStartDate('')
    setIsReset(true)
  }
  return (
    <>
      <div className='sm:flex items-center text-center sm:text-left px-3 md:px-4 xl:px-7 lg:px-5  md:py-5 py-4 md:py-8'>
        <ODateRangePicker
          handleDateChange={handleDateChange}
          isReset={isReset}
          setIsReset={setIsReset}
        />
        <button
          type='button'
          onClick={handleReset}
          className='bg-[#8FC150] text-sm px-8 mb-3 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] sm:w-auto w-1/2'
        >
          {t('O_RESET')}
        </button>
      </div>

      <div className='py-4 px-4 md:px-8'>
        <div className='sale_report grid  3xl:grid-cols-4 gap-4 2xl:grid-cols-4 sm:grid-cols-2 mb-7 '>
          {(user?.permission?.find(e => e.manager === 'customers')?.view ||
            user?.role === 'admin') && (
            <div
              className='flex items-center sm:text-left px-3 md:px-4 xl:px-6 lg:px-5 rounded-lg md:py-5 py-4 md:py-8 border'
              style={{ cursor: 'pointer' }}
              onClick={() => {
                navigate('/users')
                updatePageName(t('O_CUSTOMERS'))
              }}
            >
              <h3 className='xl:flex block items-center mb-0 text-slate-900 font-bold md:text-2xl sm:text-lg text-lg text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150]'>
                {dashboardDetails?.total_no_of_users ? (
                  <>
                    <CountUp
                      duration={0.6}
                      end={dashboardDetails?.total_no_of_users}
                    />
                  </>
                ) : (
                  0
                )}
                <span className='lg:ml-4 text-base text-neutral-400 font-normal block lg:inline-block'>
                  {t('O_USERS')}
                </span>
              </h3>
              <span className='text-4xl ml-auto sm:mr-0 mt-2 sm:mt-0'>
                <FcPortraitMode />
              </span>
            </div>
          )}

          {(user?.permission?.find(e => e.manager === 'agent_manager')?.view ||
            user?.role === 'admin') && (
            <div
              className='flex items-center  sm:text-left px-3 md:px-4 xl:px-6 lg:px-5 rounded-lg md:py-5 py-4 md:py-8 border'
              style={{ cursor: 'pointer' }}
              onClick={() => {
                navigate('/agents')
                updatePageName(t('NAV_AGENT_MANAGER'))
              }}
            >
              <h3 className='xl:flex block items-center mb-0 text-slate-900 font-bold md:text-2xl sm:text-lg text-lg text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150]'>
                {dashboardDetails?.totalNoOfAgents ? (
                  <>
                    <CountUp
                      duration={0.6}
                      end={dashboardDetails?.totalNoOfAgents}
                    />
                  </>
                ) : (
                  0
                )}
                <span className='lg:ml-4 text-base text-neutral-400 font-normal block lg:inline-block'>
                  {t('O_AGENTS')}
                </span>
              </h3>
              <span className='text-4xl ml-auto sm:mr-0 mt-2 sm:mt-0'>
                <FcNightPortrait />
              </span>
            </div>
          )}

          {(user?.permission?.find(e => e.manager === 'company_manager')
            ?.view ||
            user?.role === 'admin') && (
            <div
              className='flex items-center  sm:text-left px-3 md:px-4 xl:px-6 lg:px-5 rounded-lg md:py-5 py-4 md:py-8 border'
              style={{ cursor: 'pointer' }}
              onClick={() => {
                navigate('/company')
                updatePageName(t('NAV_MANAGE_COMPANY'))
              }}
            >
              <h3 className='xl:flex block items-center mb-0 text-slate-900 font-bold md:text-2xl sm:text-lg text-lg text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150]'>
                {dashboardDetails?.total_no_of_companies ? (
                  <>
                    <CountUp
                      duration={0.6}
                      end={dashboardDetails?.total_no_of_companies}
                    />
                  </>
                ) : (
                  0
                )}
                <span className='lg:ml-4 text-base text-neutral-400 font-normal block lg:inline-block'>
                  {t('O_COMPANIES')}
                </span>
              </h3>
              <span className='ml-auto sm:mr-0  mt-2 sm:mt-0'>
                <FcOrganization className='h-8 w-8' />
              </span>
            </div>
          )}

          {(user?.permission?.find(e => e.manager === 'property_manager')
            ?.view ||
            user?.role === 'admin') && (
            <div
              className='flex items-center  sm:text-left px-3 md:px-4 xl:px-6 lg:px-5 rounded-lg md:py-5 py-4 md:py-8 border'
              style={{ cursor: 'pointer' }}
              onClick={() => {
                navigate('/properties')
                updatePageName(t('NAV_PROPERTY_MANAGER'))
              }}
            >
              <h3 className='xl:flex block items-center mb-0 text-slate-900 font-bold md:text-2xl sm:text-lg text-lg text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150]'>
                {dashboardDetails?.totalListedProperties ? (
                  <>
                    <CountUp
                      duration={0.6}
                      end={dashboardDetails?.totalListedProperties}
                    />
                  </>
                ) : (
                  0
                )}
                <span className='lg:ml-4 text-base text-neutral-400 font-normal block lg:inline-block'>
                  {t('O_LISTED_PROPERTIES')}
                </span>
              </h3>
              <span className='ml-auto sm:mr-0  mt-2 sm:mt-0'>
                <FcDiploma2 className='h-8 w-8' />
              </span>
            </div>
          )}

          {(user?.permission?.find(e => e.manager === 'auction_manager')
            ?.view ||
            user?.role === 'admin') && (
            <div
              className='flex items-center  sm:text-left px-3 md:px-4 xl:px-6 lg:px-5 rounded-lg md:py-5 py-4 md:py-8 border'
              style={{ cursor: 'pointer' }}
              onClick={() => {
                navigate('/auction')
                updatePageName(t('NAV_PROPERTY_AUCTION_MANAGER'))
              }}
            >
              <h3 className='xl:flex block items-center mb-0 text-slate-900 font-bold md:text-2xl sm:text-lg text-lg text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150]'>
                {dashboardDetails?.totalAuctionProperties ? (
                  <>
                    <CountUp
                      duration={0.6}
                      end={dashboardDetails?.totalAuctionProperties}
                    />
                  </>
                ) : (
                  0
                )}
                <span className='lg:ml-4 text-base text-neutral-400 font-normal block lg:inline-block'>
                  {t('O_AUCTIONS')}
                </span>
              </h3>
              <span className='ml-auto sm:mr-0  mt-2 sm:mt-0'>
                <FcDeployment className='h-8 w-8' />
              </span>
            </div>
          )}

          {(user?.permission?.find(e => e.manager === 'project_manager')
            ?.view ||
            user?.role === 'admin') && (
            <div
              className='flex items-center  sm:text-left px-3 md:px-4 xl:px-6 lg:px-5 rounded-lg md:py-5 py-4 md:py-8 border'
              style={{ cursor: 'pointer' }}
              onClick={() => {
                navigate('/projects')
                updatePageName(t('NAV_PROJECT_MANAGER'))
              }}
            >
              <h3 className='xl:flex block items-center mb-0 text-slate-900 font-bold md:text-2xl sm:text-lg text-lg text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150]'>
                {dashboardDetails?.totalProjects ? (
                  <>
                    <CountUp
                      duration={0.6}
                      end={dashboardDetails?.totalProjects}
                    />
                  </>
                ) : (
                  0
                )}
                <span className='lg:ml-4 text-base text-neutral-400 font-normal block lg:inline-block'>
                  {t('O_PROJECTS')}
                </span>
              </h3>
              <span className='ml-auto sm:mr-0  mt-2 sm:mt-0'>
                <FcIdea className='h-8 w-8' />
              </span>
            </div>
          )}
          {(user?.permission?.find(e => e.manager === 'approval_manager')
            ?.view ||
            user?.role === 'admin') && (
            <div
              className='flex items-center  sm:text-left px-3 md:px-4 xl:px-6 lg:px-5 rounded-lg md:py-5 py-4 md:py-8 border'
              style={{ cursor: 'pointer' }}
              onClick={() => {
                navigate('/approval-manager')
                updatePageName(t('NAV_APPROVAL_MANAGER'))
              }}
            >
              <h3 className='xl:flex block items-center mb-0 text-slate-900 font-bold md:text-2xl sm:text-lg text-lg text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150] text-[#8FC150]'>
                {dashboardDetails?.totalAppointments ? (
                  <>
                    <CountUp
                      duration={0.6}
                      end={dashboardDetails?.totalAppointments}
                    />
                  </>
                ) : (
                  0
                )}
                <span className='lg:ml-4 text-base text-neutral-400 font-normal block lg:inline-block'>
                  {t('O_APPOINTMENTS')}
                </span>
              </h3>
              <span className='ml-auto sm:mr-0  mt-2 sm:mt-0'>
                <FcButtingIn className='h-8 w-8' />
              </span>
            </div>
          )}
        </div>
      </div>
      <div style={{ width: '500px'}}>
        {dashboardDetails?.totalProperties &&
        dashboardDetails?.totalSoldProperties ? (
          <Chart
            chartType='PieChart'
            data={data}
            options={options}
            width='120%'
            height='400px'
          />
        ) : (
          <p className='pl-8'>
            Total Properties And Sold Properties are not enough to plot graph
          </p>
        )}
      </div>
    </>
  )
}

export default Home
